






































































import Vue from 'vue'
import { Component, Prop, Ref } from 'vue-property-decorator'

import PageTitle from '../PageTitle.vue'
import CashRegisters from './CashRegisters/CashRegisters.vue'
import ShopNotices from './Notices/ShopNotices.vue'
import ShopProductReports from './ProductReports/ShopProductReports.vue'
import ShopProducts from './Products/ShopProducts.vue'
import { Pages, ShopConfig } from './types'

@Component({
  data() {
    return {
      Pages,
    }
  },
  components: {
    PageTitle,
    ShopProducts,
    CashRegisters,
    ShopNotices,
    ShopProductReports,
  }
})
export default class Shop extends Vue {
  @Prop() shopConfig!: ShopConfig

  @Ref('shop-products') productsComponent!: ShopProducts

  activePage: Pages = Pages.Products

  tabClick(activeKey: number): void {
    if (activeKey === Pages.Products && activeKey === this.activePage && this.productsComponent.archiveIsOpen) {
      this.productsComponent.archiveIsOpen = false
    }
  }

  exportToCsv(): void {
    switch (this.activePage) {
      case Pages.Products:
        this.shopConfig.exportTables.products()
        break
      case Pages.CashRegisters:
        this.shopConfig.exportTables.cashRegisters()
        break
      case Pages.Notices:
        this.shopConfig.exportTables.sales()
        break
    }
  }
}
